import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import useUserRoles from '../../hooks/useUserRoles';

const SettingsLayout = ({ children }) => {
    const { loading } = useUserRoles();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialActiveTab = queryParams.get('active')
        ? `nav-setting-tab-${queryParams.get('active')}`
        : 'nav-setting-tab-1';

    const [activeTab, setActiveTab] = useState(initialActiveTab);

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    if (loading) return null;

    return (
        <div className="container">
            <div className="row">
                {/* Sidebar START */}
                <div className="col-lg-3">
                    <nav className="navbar navbar-light navbar-expand-lg mx-0">
                        <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasNavbar">
                            <div className="offcanvas-header">
                                <button
                                    type="button"
                                    className="btn-close text-reset ms-auto"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="offcanvas-body p-0">
                                <div className="card w-100">
                                    <div className="card-body">
                                        <ul className="nav nav-tabs nav-pills nav-pills-soft flex-column fw-bold gap-2 border-0">
                                            <li className="nav-item" data-bs-dismiss="offcanvas">
                                                <a
                                                    className={`nav-link d-flex mb-0 ${activeTab === 'nav-setting-tab-1' ? 'active' : ''}`}
                                                    href="#nav-setting-tab-1"
                                                    data-bs-toggle="tab"
                                                    onClick={() => handleTabClick('nav-setting-tab-1')}
                                                >
                                                    <img
                                                        className="me-2 h-20px fa-fw"
                                                        src={`/static/images/icon/person-outline-filled.svg`}
                                                        alt=""
                                                    />
                                                    <span>Account</span>
                                                </a>
                                            </li>
                                            <li className="nav-item" data-bs-dismiss="offcanvas">
                                                <a
                                                    className={`nav-link d-flex mb-0 ${activeTab === 'nav-setting-tab-2' ? 'active' : ''}`}
                                                    href="#nav-setting-tab-2"
                                                    data-bs-toggle="tab"
                                                    onClick={() => handleTabClick('nav-setting-tab-2')}
                                                >
                                                    <img
                                                        className="me-2 h-20px fa-fw"
                                                        src={`/static/images/icon/notification-outlined-filled.svg`}
                                                        alt=""
                                                    />
                                                    <span>Notification</span>
                                                </a>
                                            </li>
                                            {/* <li className="nav-item" data-bs-dismiss="offcanvas">
                                                    <a
                                                        className={`nav-link d-flex mb-0 ${activeTab === 'nav-setting-tab-3' ? 'active' : ''}`}
                                                        href="#nav-setting-tab-3"
                                                        data-bs-toggle="tab"
                                                        onClick={() => handleTabClick('nav-setting-tab-3')}
                                                    >
                                                        <img
                                                            className="me-2 h-20px fa-fw"
                                                            src={`/static/images/icon/shield-outline-filled.svg`}
                                                            alt=""
                                                        />
                                                        <span>Privacy and safety</span>
                                                    </a>
                                                </li> */}
                                            {/* <li className="nav-item" data-bs-dismiss="offcanvas">
                                                    <a
                                                        className={`nav-link d-flex mb-0 ${activeTab === 'nav-setting-tab-4' ? 'active' : ''}`}
                                                        href="#nav-setting-tab-4"
                                                        data-bs-toggle="tab"
                                                        onClick={() => handleTabClick('nav-setting-tab-4')}
                                                    >
                                                        <img
                                                            className="me-2 h-20px fa-fw"
                                                            src={`/static/images/icon/handshake-outline-filled.svg`}
                                                            alt=""
                                                        />
                                                        <span>Communications</span>
                                                    </a>
                                                </li> */}
                                            {/* <li className="nav-item" data-bs-dismiss="offcanvas">
                                                    <a
                                                        className={`nav-link d-flex mb-0 ${activeTab === 'nav-setting-tab-5' ? 'active' : ''}`}
                                                        href="#nav-setting-tab-5"
                                                        data-bs-toggle="tab"
                                                        onClick={() => handleTabClick('nav-setting-tab-5')}
                                                    >
                                                        <img
                                                            className="me-2 h-20px fa-fw"
                                                            src={`/static/images/icon/chat-alt-outline-filled.svg`}
                                                            alt=""
                                                        />
                                                        <span>Messaging</span>
                                                    </a>
                                                </li> */}
                                            {/* <li className="nav-item" data-bs-dismiss="offcanvas">
                                                    <a
                                                        className={`nav-link d-flex mb-0 ${activeTab === 'nav-setting-tab-7' ? 'active' : ''}`}
                                                        href="#nav-setting-tab-7"
                                                        data-bs-toggle="tab"
                                                        onClick={() => handleTabClick('nav-setting-tab-7')}
                                                    >
                                                        <img
                                                            className="me-2 h-20px fa-fw"
                                                            src={`/static/images/icon/trash-var-outline-filled.svg`}
                                                            alt=""
                                                        />
                                                        <span>Close account</span>
                                                    </a>
                                                </li> */}
                                        </ul>
                                    </div>
                                    <div className="card-footer text-center py-2">
                                        <a className="btn btn-link text-secondary btn-sm" href="/profile/">
                                            View Profile
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {/* <ul className="nav small mt-4 justify-content-center lh-1">
                                    <li className="nav-item">
                                        <a className="nav-link" href="my-profile-about.html">About</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="settings.html">Settings</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" target="_blank" rel="noreferrer" href="/">Support</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" target="_blank" rel="noreferrer" href="docs/index.html">Docs</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="help.html">Help</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="privacy-and-terms.html">Privacy & terms</a>
                                    </li>
                                </ul> */}
                            <p className="small text-center mt-1">
                                ©{new Date().getFullYear()}{' '}
                                <a className="text-reset" target="_blank" rel="noreferrer" href="https://www.webestica.com/">
                                    Lemont Rec Leagues
                                </a>
                            </p>
                        </div>
                    </nav>
                </div>
                {/* Sidebar END */}

                {/* Main content area */}
                <div className="col-lg-9">
                    <div className="tab-content p-0" id="settingsTabContent">
                        {React.cloneElement(children, { activeTab })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsLayout;
